export const itemTypeOpts = [
    { label: '一口价', value: 1 },
]
export const itemBizTypeOpts = [
    { label: '普通商品', value: 2 },
]

export const stuffStatusTypeOpts = [
    { label: '有成色', value: 1 },
    { label: '无成色', value: 0 },
]
export const stuffStatusOpts = [
    { label: '全新', value: 100 },
    { label: '准新', value: -1 },
    { label: '99新', value: 99 },
    { label: '95新', value: 95 },
    { label: '9新', value: 90 },
    { label: '8新', value: 80 },
    { label: '7新', value: 70 },
    { label: '6新', value: 60 },
    { label: '5新', value: 50 },
    { label: '未使用·中度瑕疵', value: 40 },
    { label: '未使用·轻微瑕疵', value: 30 },
    { label: '未使用·仅拆封', value: 20 },
    { label: '未使用·准新', value: 10 }

]